// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav_document_analyzer-module__chip--3ENe2{position:absolute;top:-7px;right:0}\n", ""]);
// Exports
exports.locals = {
	"chip": "nav_document_analyzer-module__chip--3ENe2"
};
module.exports = exports;
